// extracted by mini-css-extract-plugin
module.exports = {"code-of-ethics":"CodeOfEthics_code-of-ethics__B51Bl","container":"CodeOfEthics_container__V7NfQ"};